var GdsHeroCarouselGradient;
(function (GdsHeroCarouselGradient) {
  GdsHeroCarouselGradient["gradient_1"] = "gradient-1";
  GdsHeroCarouselGradient["gradient_2"] = "gradient-2";
  GdsHeroCarouselGradient["gradient_3"] = "gradient-3";
})(GdsHeroCarouselGradient || (GdsHeroCarouselGradient = {}));

export { GdsHeroCarouselGradient as G };

